import React from 'react';
import { SectionAbout } from '../components/SectionAbout/SectionAbout';
import { SectionSkills } from '../components/SectionSkills/SectionSkills';

export const About = () => {
  return(
    <>
      <SectionAbout />
      <SectionSkills />
    </>
  );
};